import { useCallback } from 'react';
import FroalaEditor from 'react-froala-wysiwyg';

import { ToniAIMapping } from '../../../../toni-ai/types';

const TONI_AI_INSERTED_ID = 'toni-ai-insert';

const checkMapping = (value: string, mapping: ToniAIMapping) => {
  let result = value;

  if (mapping) {
    Object.keys(mapping).forEach((key) => {
      switch (key) {
        case 'links':
          Object.keys(mapping[key]).forEach((linkKey) => {
            const regex = new RegExp(
              `${linkKey}([\\s\\S]*?)</${linkKey.substring(1)}`,
              'g'
            );
            result = result.replace(regex, mapping[key][linkKey] as string);
          });
          break;
        case 'images':
          Object.keys(mapping[key]).forEach((linkKey) => {
            result = result.replace(linkKey, mapping[key][linkKey] as string);
          });
          break;
        default: {
          const regex = new RegExp(
            `${key}([\\s\\S]*?)</${key.substring(1)}`,
            'g'
          );
          result = result.replace(regex, mapping[key] as string);
        }
      }
    });
  }
  return result;
};

const useComposeToniAiEmail = () => {
  const composeEmail = useCallback(
    (
      result: string,
      mapping: ToniAIMapping,
      completed: boolean,
      editor: FroalaEditor,
      toniAiHtml: string
    ) => {
      const editorInstance = editor?.getEditor();
      editorInstance?.selection.restore();

      const html = toniAiHtml;

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const selectionMarkers = doc.querySelectorAll('.fr-marker');

      if (selectionMarkers.length === 2) {
        const selectionStart = selectionMarkers[0];
        const selectionEnd = selectionMarkers[1];

        const selectionRange = doc.createRange();
        selectionRange.setStartAfter(selectionStart);
        selectionRange.setEndBefore(selectionEnd);
        selectionRange.deleteContents();

        const replacement = doc.createElement('div');
        replacement.setAttribute('id', TONI_AI_INSERTED_ID);
        replacement.innerHTML = result;

        /** Setting parent styles on inserted <p> tags */
        const styles = selectionStart.parentElement?.getAttribute('style');
        if (styles) {
          for (let i = 0; i < replacement.children.length; i++) {
            replacement.children.item(i).setAttribute('style', styles);
          }
        }

        selectionRange.insertNode(replacement);

        /** Removing the wrapping div */
        const insertedNode = doc.getElementById(TONI_AI_INSERTED_ID);
        insertedNode.outerHTML = replacement.innerHTML;

        /** Setting the html */
        editorInstance?.html.set(checkMapping(doc.body.innerHTML, mapping));
      }

      if (completed) {
        editorInstance?.selection.clear();
      }
    },
    []
  );

  return { composeEmail };
};

export default useComposeToniAiEmail;
